<template>
    <div class="container">

        <!-- Header row -->
        <div class="row header">
            <div class="col-6 titles">Produits</div>
            <div class="col-2 titles text-left d-none d-md-block">Quantité</div>
            <div class="col-2 titles text-center d-none d-md-block">Prix</div>
            <div class="col-2 titles text-right d-none d-md-block">Sous Total</div>
        </div>

        <!-- Items rows -->
        <div v-for="(item, index) in cartItems" :key="index" class="row item-row pt-4 pb-4">
            <!-- Web Version -->
            <div class="col-6 text-left d-none d-md-block">
                <div class="product-info">
                    <a :href="'/catalogue' + item.url"><img class="imageClass" v-bind:src="'/api/image/get/product/small/' + getItemVariantImage(item)" alt="" /></a>
                    <div class="product-details pb-3 pt-3">
                        <div class="product-name pb-3 "><a :href="'/catalogue' + item.url">{{ item.title }}</a></div>
                        <div class="product-size-color pb-3">Taille: {{ getItemVariantSize(item) }}, Couleur: {{ getItemVariant(item).color.name }}</div>
                        <div class="button pb-2" @click="deleteCartItem(item)">
                            <img class="icontrash" alt="" src="../assets/images/trash.svg" />
                            <div class="delete">Supprimer</div>
                        </div>  
                    </div>
                </div>
            </div>
            <div class="col-2 text-left d-none d-md-block">
                <div class="quanity-container">
                    <div class="content3">
                        <img class="iconminus" @click="decreaseQuantity(item)" alt="" src="../assets/images/Minus.svg" />
                        <div :class="{'quantity-loading': isQuantityEditing}" class="quantity-text "> {{ item.cartItemQuantity }}</div>
                        <img class="iconadd" alt="" @click="increaseQuantity(item)" src="../assets/images/Add.svg" />
                    </div>
                </div>
            </div>
            <div class="col-2 text-center d-none d-md-block priceClass">{{ item.priceDiscounted }}</div>
            <div class="col-2 text-right d-none d-md-block subtotalClass">{{ item.cartItemSubTotal }}</div>

            

            <!-- Mobile Version -->
            <div class="col-12   d-md-none">
                <div class="row">
                    <div class="col-3">
                        <a :href="'/catalogue' + item.url"><img class="imageClass" v-bind:src="'/api/image/get/product/small/' + getItemVariantImage(item)" alt="" /></a>
                    </div>
                    
                  
                        <div class="col-9">

                    
                            <div class="product-details  ">
                                <div class="row">
                                    <div class="col-11">
                                        <div class="product-name   "><a :href="'/catalogue' + item.url">{{ item.title }}</a></div>
                                    </div>
                                    <div class="col-1 text-right"> <div  @click="deleteCartItem(item)">
                                        <img class="icontrash" alt="" src="@/assets/icons/trash.svg" />
                                    </div>  </div>
                                </div>
                                
                                <div class="product-size-color mt-1">Taille: {{ getItemVariantSize(item) }}, Couleur: {{ getItemVariant(item).color.name }}</div>
                                


                                




                                <div class=" text-left subtotalClass mt-2 mb-3">{{ item.cartItemSubTotal }}</div>                             
                                
                                <div class="quanity-container">
                                    <div class="content3">
                                        <img class="iconminus" @click="decreaseQuantity(item)" alt=""
                                            src="../assets/images/Minus.svg" />
                                        <div class="quantity-text">{{ item.cartItemQuantity }}</div>
                                        <img class="iconadd" alt="" @click="increaseQuantity(item)"
                                            src="../assets/images/Add.svg" />
                                    </div>
                                </div>

                                

                            </div>

                        </div>


    


                                 


                </div>
            </div>
            

            <CartNotification v-if="item.cartItemDelayWarning"></CartNotification>

        </div>
    </div>
</template>
<script >
import CartNotification from "@/components/cartNotification.vue"

export default ({
    name: "ElementsCartCartItems",
    components: {
        CartNotification
    },

    props: {
        cart:{
            type: Object,
            default:null
        },
    },

    data() {
        return {
            isQuantityEditing: false,
        };
    },

    computed: {
        cartItems() {
            return this.cart && this.cart.lines ? this.cart.lines.list : [];
        },

        isCartLoading() {
            return this.$store.state.isLoadingCart;
        }
    },

    methods: {

        getItemVariantImage(item) {
            let variant = this.getItemVariant(item);
            return variant && variant.itemsVariantImages && variant.itemsVariantImages.length ? variant.itemsVariantImages[0] : item.image;
        },

        getItemVariantSize(item) {
            return Object.keys(item.sizes) && Object.keys(item.sizes).length ? Object.keys(item.sizes)[0] : null;
        },

        getItemVariant(item) {
            let size = this.getItemVariantSize(item);
            return size && item.sizes[size] && item.sizes[size].length ? item.sizes[size][0] : size;
        },

        increaseQuantity(item) {
            let variant = this.getItemVariant(item);
            if (variant && variant.id) {
                this.isQuantityEditing=true;
                this.$store.dispatch('addToCart', [{ itemVariantId: variant.id, quantity: 1 }])
                .finally(() => {
                    this.isQuantityEditing = false;
                });
            }
            
        },
        
        decreaseQuantity(item) {
            if (item.cartItemQuantity == 1) {
                return;
            } 

            let variant = this.getItemVariant(item);
            if (variant && variant.id) {
                this.isQuantityEditing=true;
                this.$store.dispatch('addToCart', [{ itemVariantId: variant.id, quantity: -1 }])
                .finally(() => {
                    this.isQuantityEditing = false;
                });
            }

        },

        deleteCartItem(item) {
            
            const variant = this.getItemVariant(item)
            this.$store.dispatch('removeFromCart', variant.id);
        },
    },
})


</script>
            
<style scoped>

.container {
    align-items: center;

}

.header {
    display: flex;
    width: 100%;
    /*max-width: 960px;*/
    margin: 0 auto;
    border-bottom: 1px solid #cbcbcb;
    color:#121212;
}

.item-row {
    display: flex;
    width: 100%;
   /* max-width: 960px;*/
    margin: 0 auto;
    border-bottom: 1px solid #cbcbcb;
}

.titles {
    flex: 1;
    position: relative;
    height: 28px;
    font-size: 16px;
    letter-spacing: -0.4px;
    line-height: 28px;
    font-weight: 500;
    font-family: 'Space Grotesk';
}

.imageClass {
    width: 100%;
    max-width: 100px;
    height: auto;
}

.product-info {
    display: flex;
}

.product-details {
    margin-left: 16px;
}

.product-name {
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
    font-family: Inter;
    gap: 4px;

}

.product-size-color {
    font-size: 14px;
    line-height: 20px;
    font-family: Inter;
    color: #605f5f;
    text-align: left;
}

.button {
    display: flex;
    gap: 4px;
    cursor: pointer;
    align-items: center;
}

/* Mobile Version */
@media screen and (max-width: 767px) {
    .button {
        justify-content: flex-end;
    }
}

/* Web Version */
@media screen and (min-width: 768px) {
    .button {
        flex-direction: row;
        justify-content: flex-start;
    }
}


.icontrash {
    position: relative;
    width: 18px;
    height: 18px;
}

.delete {
    position: relative;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    font-family: 'Space Grotesk';
    color: #ff4550;
}

.quanity-container {
    display: flex;
    height: 100%;
}

/* Web Version */
@media (min-width: 576px) {
    .quanity-container {
        align-items: center;
    }
}

/* Mobile Version */
@media (max-width: 575.98px) {
    .quanity-container {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }
}

.content3 {
    position: absolute;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #cbcbcb;
    box-sizing: border-box;
    width: 80px;
    height: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px 8px;
    text-align: center;
    font-size: 12px;
    margin: auto;
}

.quantity-loading {
  position: relative;
  
}

.quantity-loading:before {
  content: '';
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 60%;
  width: 20px;
  height: 100%;
  margin-top: -10px;
  margin-left: -10px;
  border: 3px solid transparent;
  border-top: 3px solid #121212; 
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.iconminus {
    position: absolute;
    top: calc(50% - 8px);
    left: 5px;
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.iconadd {
    position: absolute;
    top: calc(50% - 8px);
    right: 5px;
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.quantity-text {
    position: absolute;
    top: calc(50% - 10px);
    left: calc(50% - 3px);
    line-height: 20px;
    font-weight: 600;
    color: #121212;
}

.priceClass {
    margin: auto;
    font-size: 18px;
    line-height: 30px;
    font-family: Inter;
    color: #121212;
}

.subtotalClass {
    margin: auto;
    font-weight: 600;
    font-family: Inter;
    color: #121212;
}

/* Web Version */
@media (min-width: 576px) {
    .subtotalClass {
        font-size: 18px;
        line-height: 30px;
    }
}

/* Mobile Version */
@media (max-width: 575.98px) {
    .subtotalClass {
        font-size: 14px; /* Adjust the font size for mobile */
        line-height: 24px; /* Adjust the line height for mobile */
    }
}
</style>